import apiHandling from "./apiHandling";

class apiTestTrainings extends apiHandling {
    static getDefaultTests = () => this.req({
            method: 'get',
            action: 'test/defaults'
        });
    static getAssignetTests = (employeeUUID)=>this.req(
        {
            method:'get',
            action:'test/assigned/'+employeeUUID
        }
    )
    static getQuestion = (questionId)=>this.req({
        method:"get",
        action:"questions/byId/"+questionId
    })

    static setResults = (data)=>this.req({
        method:"post",
        action:"/training_questions/results",
        data:JSON.stringify(data)
    });

    static getSpecialTest = (limit = 50, offset = 0) => {
        // limit: целое, 1..500, иначе дефолт 50
        const safeLimit = Number.isInteger(limit) && limit >= 1 && limit <= 500
            ? limit
            : 50;

        // offset: целое >= 0, иначе дефолт 0
        const safeOffset = Number.isInteger(offset) && offset >= 0
            ? offset
            : 0;

        return this.req({
            method: 'get',
            action: '/training_questions/special-sets',
            data: {
                limit: safeLimit,
                offset: safeOffset,
            },
        });
    };
    static getEmployeeResults = (employeeId) => {
        const parsedId = Number(employeeId);

        if (!Number.isInteger(parsedId) || parsedId <= 0) {
            return Promise.reject(new Error('employeeId must be a positive integer'));
        }

        return this.req({
            method: 'get',
            action: `/training_questions/results/employee/${parsedId}`,
        });
    };
}

export default apiTestTrainings;